import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Network from '../../../models/Network.js';

import FilterListElement from '../list_elements/FilterListElement.js';
import LoadingListElement from '../list_elements/LoadingListElement.js';
import ReportListElement from '../list_elements/ReportListElement.js';
import GraphApiTimesReports from '../graphics/GraphApiTimesReports.js';
import TypeTag from '../tags/TypeTag.js';
import './Module.css';

const key = process.env.REACT_APP_CLIENT_ACCESS_KEY;
const URLS = require("../../../urls.js");

const StatusCodes = require('../../../status-codes/status-codes.js')
const ErrorCodes = require('../../../error-codes/error-codes.js')

const TimeGraphsModule = ({user, isSmallScreen}) => {

    const [jsonData, setJsonData] = useState(null);
    const [filterDict, setFilterDict] = useState(null);
    const [medicsData, setMedicsData] = useState(null);
    
    const graphParams = {
        width: 700,
        height: 400
    }

    // function that gets multiple reports with analytics data from the server
    const getSeveralReportsAnalyticsFiltered = async (desiredNumber, reportOffset, filterDict) => {
        
        const url = URLS.GET_SEVERAL_REPORTS_ANALYTICS_FILTERED;
        const dict = {
            uid: user.uid,
            number_of_reports: desiredNumber,
            offset: reportOffset,
            filter_dict: filterDict,
            CLIENT_ACCESS_KEY: key
        };

        let responseData;

        await Network.post(url, dict, (response) => {

            responseData = response.data;

            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something

            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")

            } else {
                console.log("Unknown Error")
            }
        });

        return responseData;
    };

    const getAllAgencyMedics = async (agencyId) => {
        const url = URLS.GET_MEDICS_FOR_USER;
        const dict = {
            uid: user.uid,
            agency_id: agencyId,
            CLIENT_ACCESS_KEY: key
        };

        let responseData;

        await Network.post(url, dict, (response) => {
            responseData = response.data;

            const extractedErrorCode = responseData.toString();
            const status = response.status

            if (Network.checkValidStatusAndResponse(response)) {
                // do something
            } else if (status == StatusCodes.INTERNAL_SERVER_ERROR) {
                console.log("Server Error")
            } else {
                console.log("Unknown Error")
            }
        });

        return responseData;
    };

    // get all medics from the server
    useEffect(() => {
        getAllAgencyMedics(user.uid)
            .then((data) => {
                setMedicsData(data);
            })
            .catch((error) => {
                console.log('Error:', error);
            });
    }, []);

    // get report analytics data from the server
    useEffect(() => {
        // Only load data when user has selected a date filter
        if (filterDict && (filterDict.lowerDate || filterDict.upperDate)) {
            getSeveralReportsAnalyticsFiltered(5000, 0, filterDict) // max 5000 reports, no offset
                .then((data) => {
                    setJsonData(data); // TODO: add protection against API failure
                    console.log('Setting JSON data:', data);
                })
                .catch((error) => {
                    console.log('Error:', error);
                });
        } else {
            // Clear data if no date filter is set
            setJsonData(null);
        }
    }, [filterDict]);

    
    return (
        <div className={isSmallScreen ? "standard-module-screen-small" : "standard-module"}>
            <FilterListElement
                medicsData={medicsData}
                filterState={
                    {
                        date: [],
                        read: ["both"],
                        finished: ["both"]
                    }
                }
                dictUpdateHandler={setFilterDict}
                showClearButton={false}
                filterDropdownsVisible={{
                    date: true,
                    medics: true,
                    typeTags: true,
                    // measures: false - not included for time graphs
                }}
            />
            {!filterDict || (!filterDict.lowerDate && !filterDict.upperDate) ? (
                <div style={{ padding: '20px', textAlign: 'center' }}>
                    <h4 className='module-subtitle'>Select a date range above to visualize time analysis data.</h4>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
                    {jsonData ? (
                        <div>
                            <GraphApiTimesReports 
                                data={jsonData} 
                                graphParams={graphParams}
                            />
                        </div>
                    ) : (
                        <LoadingListElement height={400} backgroundColor="white"/>
                    )}
                </div>
            )}
        </div>
    );
}

export default TimeGraphsModule; 